// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import styled from 'styled-components';
import CloseIcon from '../../../../assets/images/sidebar-close-icon.svg';
import Tabs from '../../../Tabs';
import TabStyle from '../../../Tabs/styles';

const otherS = {
  Wrapper: styled.div<{ isOpened: boolean }>`
    position: relative;
    background: #FFF;
    filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));
    transition: width 0.5s ease-in;
    width: ${props => props.isOpened ? '350' : '0'}px;

    & > div {
      overflow: hidden;
    }
  `,
  Container: styled.div`
    width: 350px;
    height: 100%;
    display: flex;
    flex-direction: column;
  `,
  Title: styled.div`
    font-weight: 700;
    font-size: 18px;
    margin: 16px;
    color: #434343;
  `,
  Tabs: styled(Tabs)`
    margin-top: 8px;
  `,
  TabContainer: styled.div`
    display: flex;
    margin-top: 8px;
  `,
  TabTitle: styled.div<{ isShown: boolean }>`
    display: flex;
    align-items: center;
    justify-content: center;

    min-width: 175px;
    height: 32px;

    font-weight: ${({ isShown }) => isShown ? 700 : 400 };
    font-size: 16px;
    color: ${props => props.isShown ? '#EF8200' : '#848484'};
    border-bottom: ${props => props.isShown ? '3px solid #EF8200' : '1px solid #DEDEDE'};
    cursor: pointer;
  `,
  CloseContainer: styled.div`
    position: absolute;
    top: 0;
    left: -30px;
    z-index: -1;

    width: 30px;
    height: 60px;
    border-top-left-radius: 60px;
    border-bottom-left-radius: 60px;
    background: #FFF;
    display: flex;
    align-items: center;
    padding-left: 12px;
    cursor: pointer;
  `,
  CloseIcon: styled.img.attrs({ src: CloseIcon, alt: 'close-icon' })<{ isOpened: boolean }>`
    transition: transform 0.5s;
    transform: rotate(${props => props.isOpened ? '0' : '-180'}deg);
  `,
  ContentContainer: styled.div`
    overflow-y: auto;
    flex: 1;
  `,
  LoadingContainer: styled.div`
    display: flex;
    height: 100%;
    width: 100%;
    align-items: center;
    justify-content: center;
  `,
};

export const S = {
  ...otherS
}
